import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@mlb/react-patterns/v4/components/Skeleton/skeleton';
import { TeamComparisonTabList, TeamComparisonWrapper, TitleWrapper, SkeletonWrapper, SkeletonTabs } from './TeamStats.style';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';
import { TabsContext, TabPanel } from '@mlb/react-patterns/v4/components/Tabs/tabs';

const buildSkeleton = () => {
    return <SkeletonWrapper>
        <Skeleton width='270px' height='118px' />
        <Skeleton isCircle width='40px' height='40px' />
        <Skeleton isCircle width='40px' height='40px' />
    </SkeletonWrapper>;
};

const buildSkeletonTabs = () => {
    return <SkeletonTabs>
        <Skeleton width='49px' height='35px' margin='22px' />
        <Skeleton width='113px' height='35px' margin='22px' />
        <Skeleton width='67px' height='35px' margin='22px' />
    </SkeletonTabs>;
};

const fragment = ({ children }) => <>{children}</>;
const TeamComparison = ({
    slides,
    handleTabChange,
    teamComparisonGameType,
    isLoading = false,
    contentContainer
}) => {
    const translate = useTranslate();

    const onClickHandler = useCallback((event) => {
        handleTabChange(event);
    }, [handleTabChange]);

    const handlers = useMemo(() => {
        return {
            onClick: onClickHandler
        };
    }, [handleTabChange]);

    const titleMap = {
        game: translate('label_game', 'Game'),
        season: translate('label_season', 'Season'),
        alltime: translate('label_alltime', 'All-Time'),
        season_postseason: translate('label_series', 'Series')
    };

    const title = (teamComparisonGameType !== 'P') ? translate('label_team_comparison', 'Team Comparison') : translate('label_postseason_team_comparison', 'Postseason Team Comparison');
    const list = [];

    slides.forEach((slide) => {
        const tabType = slide.props.type;
        list.push({
            name: titleMap[`${tabType}${(teamComparisonGameType === 'P' && tabType === 'season') ? '_postseason' : ''}`],
            children: slide,
            handlers: (handleTabChange) ? handlers : {}
        });
    });

    const TableContainer = contentContainer || fragment;
    return (
        list.length > 0
            ? <TeamComparisonWrapper>
                <TitleWrapper>{ isLoading ? <Skeleton height='28px' width='129px' /> : title}</TitleWrapper >
                <TableContainer>
                    <TabsContext initialActiveTab={list[0].name}>
                        { isLoading ? buildSkeletonTabs() : (list.length > 1 ? <TeamComparisonTabList list={list} /> : null) }
                        { isLoading
                            ? buildSkeleton()
                            : list.map((tab) => (
                                <TabPanel key={tab.name} name={tab.name}>
                                    {tab.children}
                                </TabPanel>
                            )) }
                    </TabsContext>
                </TableContainer>

            </TeamComparisonWrapper>
            : null

    );
};

TeamComparison.propTypes = {
    slides: PropTypes.array,
    handleTabChange: PropTypes.func,
    teamComparisonGameType: PropTypes.string,
    isLoading: PropTypes.bool
};

export default TeamComparison;
